export const css = {
    oneaction: '_7Ob2W5MP',
    primaryButton: 'inZ3m1YR',
    ' _key': 'apic-theme/apic/micro/quiz-widgets/questionfeedback'
};
export default css;
